import { useCallback, useEffect, useState } from "react";
import { useService } from "../../../../hooks";

export const useDashboard = () => {
  const { getLoggedInUserData } = useService("User");
  const { setTitle } = useService("Meta");
  const { getUserRecommendation } = useService("Order");
  const user = getLoggedInUserData();
  const [recommendData, setrecommendData] = useState([]);
  const [activeService] = useState(null);
  const [userData] = useState(user);

  setTitle("Dashboard");

  const getRecommendation = useCallback(async () => {
    let query = {
      uid: user.uid,
    };
    const result = await getUserRecommendation(query);
    if (result.status) {
      if (result.data?.length === 0) {
        setrecommendData(null);
      } else {
        setrecommendData(result.data);
      }
    }
  }, [user.uid, getUserRecommendation]);

  useEffect(() => {
    getRecommendation();
  }, [getRecommendation]);

  return {
    activeService,
    user,
    userData,
    recommendData,
  };
};
